import { GeoJsonPoint, OnlineStatusEnum } from 'src/app/shared/models/telemetry.model';
import { CommonTelemetryService } from 'src/app/shared/services/telemetry.service';
import { ConnectivityModuleDto, ServiceVanMasterDataDto } from './servicevan.model.dto';

/**
 *
 */
export class ServiceVanMasterDataSto {
  aggregateId: string;
  aggregateType: string;
  name: string;
  serial: string;
  workshopId: string;
  vehicleIdentificationNumber: string;
  productIdentificationNumber: string;

  tmGpsPosition?: GeoJsonPoint;
  tmGpsPositionMeasuredAt?: Date;
  tmDistanceCounter?: number;
  tmDistanceCounterMeasuredAt?: Date;
  tmIgnitionKeySwitch?: number;
  tmIgnitionKeySwitchMeasuredAt?: Date;
  tmOperatingHours?: number;
  tmOperatingHoursMeasuredAt?: Date;
  tmOnlineStatus?: OnlineStatusEnum;
  tmStatusUpdatedAt?: Date;

  connectivityModule?: ConnectivityModuleDto;

  constructor(dto: ServiceVanMasterDataDto) {
    this.aggregateId = dto?.aggregateId;
    this.aggregateType = dto?.aggregateType;
    this.name = dto?.name;
    this.serial = dto?.serial;
    this.workshopId = dto?.workshopId;
    this.vehicleIdentificationNumber = dto?.vehicleIdentificationNumber;
    this.productIdentificationNumber = dto?.productIdentificationNumber;

    this.tmGpsPosition = dto?.tmGpsPosition;
    this.tmGpsPositionMeasuredAt = dto?.tmGpsPositionMeasuredAt;
    this.tmDistanceCounter = dto?.tmDistanceCounter;
    this.tmDistanceCounterMeasuredAt = dto?.tmDistanceCounterMeasuredAt;
    this.tmIgnitionKeySwitch = dto?.tmIgnitionKeySwitch;
    this.tmIgnitionKeySwitchMeasuredAt = dto?.tmIgnitionKeySwitchMeasuredAt;
    this.tmOperatingHours = dto?.tmOperatingHours;
    this.tmOperatingHoursMeasuredAt = dto?.tmOperatingHoursMeasuredAt;
    this.tmOnlineStatus = dto?.tmOnlineStatus;
    this.tmStatusUpdatedAt = dto?.tmStatusUpdatedAt;

    this.connectivityModule = dto?.connectivityModule;
  }
}

/**
 *
 */
export class ServiceVanListTableRow {
  rowId: string;
  aggregateId: string;
  aggregateType: string;
  name: string;
  serial: string;
  simIccid?: string;
  model?: string;
  configVersion?: string;
  hardwareVersion?: string;
  firmwareVersion?: string;
  onlineStatus?: OnlineStatusEnum;
  onlineStatusCode?: number;
  totalDistance?: number;
  totalOperationHours?: number;
  latestContact?: Date;
  latestGpsPosition?: GeoJsonPoint;
  workshopId: string;
  workshop?: RelatedWorkshopSto;

  constructor(serviceVanSto: ServiceVanMasterDataSto, workshop?: RelatedWorkshopSto) {
    this.rowId = serviceVanSto?.aggregateId;
    this.aggregateId = serviceVanSto?.aggregateId;
    this.aggregateType = serviceVanSto?.aggregateType;
    this.name = serviceVanSto?.name;
    this.serial = serviceVanSto?.serial;
    this.simIccid = serviceVanSto?.connectivityModule?.simIccid;
    this.model = serviceVanSto?.connectivityModule?.model;
    this.configVersion = serviceVanSto?.connectivityModule?.configVersion;
    this.hardwareVersion = serviceVanSto?.connectivityModule?.hardwareVersion;
    this.firmwareVersion = serviceVanSto?.connectivityModule?.firmwareVersion;
    this.onlineStatus = serviceVanSto?.tmOnlineStatus;
    this.onlineStatusCode = CommonTelemetryService.getOnlineStatusCode(serviceVanSto?.tmOnlineStatus);
    this.totalDistance = serviceVanSto?.tmDistanceCounter;
    this.totalOperationHours = serviceVanSto?.tmOperatingHours;
    this.latestContact = serviceVanSto?.tmStatusUpdatedAt;
    this.latestGpsPosition = serviceVanSto?.tmGpsPosition;
    this.workshopId = serviceVanSto.workshopId;
    this.workshop = workshop;
  }
}

export class RelatedWorkshopSto {
  aggregateId: string;
  aggregateType: string;
  countryCode: string;
  location: string;
  name: string;
  name2: string;
  salesOrganization: string;

  constructor(dto: RelatedWorkshopSto) {
    this.aggregateId = dto?.aggregateId;
    this.aggregateType = dto?.aggregateType;
    this.countryCode = dto?.countryCode;
    this.location = dto?.location;
    this.name = dto?.name;
    this.name2 = dto?.name2;
    this.salesOrganization = dto?.salesOrganization;
  }
}

export class ServiceVanCardInfoSto {
  aggregateId: string;
  aggregateType: string;
  serial: string;
  name: string;
  onlineStatus?: OnlineStatusEnum;
  onlineStatusCode?: number;
  totalDistance?: number;
  totalOperationHours?: number;
  latestContact?: Date;
  latestGpsPosition?: GeoJsonPoint;

  constructor(serviceVanSto: ServiceVanMasterDataSto) {
    this.aggregateId = serviceVanSto?.aggregateId;
    this.aggregateType = serviceVanSto?.aggregateType;
    this.name = serviceVanSto?.name;
    this.serial = serviceVanSto?.serial;
    this.onlineStatus = serviceVanSto?.tmOnlineStatus;
    this.onlineStatusCode = CommonTelemetryService.getOnlineStatusCode(serviceVanSto?.tmOnlineStatus);
    this.totalDistance = serviceVanSto?.tmDistanceCounter;
    this.totalOperationHours = serviceVanSto?.tmOperatingHours;
    this.latestContact = serviceVanSto?.tmStatusUpdatedAt;
    this.latestGpsPosition = serviceVanSto?.tmGpsPosition;
  }
}
